import { createFileRoute } from '@tanstack/react-router'
import { CreateExamPage } from '_/features/pets/ui/pages/create-exam-page'

const CreateExamRoute = () => {
	const { petId } = Route.useParams()
	return <CreateExamPage petId={petId} />
}

export const Route = createFileRoute('/_authenticated/pets/$petId/exams/create')({
	staticData: { title: 'exams_create_title' },
	component: CreateExamRoute,
})
